import React from "react";

type PaziaLoaderSize = "medium" | "small";
interface PaziaLoaderProps {
  position?: "inline" | "center";
  size?: PaziaLoaderSize;
}

const sizeClasses = {
  medium: "h-8 w-8",
  small: "h-3 w-3",
} as const;

export const PaziaInlineLoader = ({
  size = "medium",
}: {
  size?: PaziaLoaderSize;
}) => {
  return (
    <div
      className={`inline-block ${sizeClasses[size]} animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]`}
      role="status"
    >
      <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
        Loading...
      </span>
    </div>
  );
};

export const PaziaLoader = ({
  position = "inline",
  size = "medium",
}: PaziaLoaderProps): JSX.Element => {
  return (
    <div
      className={`h-full w-full ${
        position === "center" ? "absolute left-1/2 top-1/2" : ""
      }`}
    >
      <PaziaInlineLoader size={size} />
    </div>
  );
};
